import Box from "@/components/Box";

export function ReportListCardTitle({ name, color = "dark" }) {
  if (!name) {
    return null;
  }

  return (
    <Box
      fontFamily="gilroyBold"
      lineHeight="36px"
      fontSize={[24, 24, 28]}
      data-testid="reportListCard:title"
      color={color}
    >
      {name}
    </Box>
  );
}
